import { Separator } from "@/components/ui/separator"
import { useEffect, useState } from "react"
import { framesStorageService } from "@/features/frames/frames-store"
import { formatFileSize } from "@/lib/utils"
import { LOCAL_LIBRARY_ID } from "@/lib/browser-persistence"

interface StatusBarProps {
  videoName: string | null
  currentFrame: number
  videoId?: string | null
}

export function StatusBar({ videoName, currentFrame, videoId }: StatusBarProps) {
  const [capturedCount, setCapturedCount] = useState(0)
  const [totalSize, setTotalSize] = useState(0)

  useEffect(() => {
    async function loadStats() {
      try {
        if (videoId) {
          // Get frames for this video
          const frames = await framesStorageService.getFramesByVideo(videoId)
          setCapturedCount(frames.length)
          setTotalSize(frames.reduce((sum, f) => sum + f.fileSize, 0))
        } else {
          // Get all frames for user
          const stats = await framesStorageService.getFrameStorageStats(LOCAL_LIBRARY_ID)
          setCapturedCount(stats.count)
          setTotalSize(stats.totalSize)
        }
      } catch (error) {
        console.error('Failed to load frame stats:', error)
      }
    }
    
    loadStats()
    
    // Refresh periodically
    const interval = setInterval(loadStats, 5000)
    return () => clearInterval(interval)
  }, [videoId])

  return (
    <div className="flex items-center w-full h-9 px-4 md:pl-36 text-xs border-t bg-muted">
      <div className="flex-1">
        <span className="font-medium">Video: </span>
        <span className="text-muted-foreground">
          {videoName || "<none>"}
        </span>
      </div>
      
      <Separator orientation="vertical" className="mx-2 h-4" />
      
      <div className="flex-1">
        <span className="font-medium">Captured: </span>
        <span className="text-muted-foreground">
          {capturedCount} frame{capturedCount !== 1 ? 's' : ''} ({formatFileSize(totalSize)})
        </span>
      </div>
      
      <Separator orientation="vertical" className="mx-2 h-4" />
      
      <div className="flex-shrink-0">
        <span className="font-medium">Current Frame: </span>
        <span className="text-muted-foreground">
          {videoName ? currentFrame + 1 : 0}
        </span>
      </div>
    </div>
  )
}